import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { BranchConstants } from 'src/constants';
import { MainTitle, MenuID } from 'src/types';

// default value for each path
var getDefaultPathParams = function getDefaultPathParams(path) {
  var _MenuID$client$MenuID;

  return (_MenuID$client$MenuID = {}, _defineProperty(_MenuID$client$MenuID, MenuID.client, {
    tabName: BranchConstants.MAIN_MENU_FUNCTIONS.includes(MainTitle.therapy) ? MainTitle.therapy : MainTitle.bodyMass,
    clientID: null
  }), _defineProperty(_MenuID$client$MenuID, MenuID.client_list, {
    tabName: MainTitle.therapy,
    clientID: null
  }), _MenuID$client$MenuID)[path];
};

var useNavigation = function useNavigation() {
  var _useRouter = useRouter(),
      defaultLocale = _useRouter.defaultLocale,
      locale = _useRouter.locale,
      replace = _useRouter.replace,
      push = _useRouter.push;

  var navigate = useCallback(function (path) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var defaultPathParams = getDefaultPathParams(path);
    var prefix = locale === defaultLocale ? '' : "/".concat(locale);
    var queryParams = new URLSearchParams();

    if (defaultPathParams) {
      Object.entries(defaultPathParams).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            defaultValue = _ref2[1];

        queryParams.set(key, params[key] || (defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''));
      });
    }

    var url = "".concat(prefix).concat(path, "?").concat(queryParams.toString());

    if (options.newTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else if (options.replace) {
      replace(url);
    } else {
      push(url);
    }
  }, [defaultLocale, locale, replace, push]);
  return {
    navigate: navigate
  };
};

export default useNavigation;